import youTube from '../../../shared/assets/icons/youtube.svg';
import instagram from '../../../shared/assets/icons/instagram.svg';
import tiktok from '../../../shared/assets/icons/tiktok.svg';
import facebook from '../../../shared/assets/icons/facebook.svg';

export const data = [
    {
        img: youTube,
        title: 'youTube',
        link: 'https://www.youtube.com/@smartclubcanada8268/videos'
    },
    {
        img: instagram,
        title: 'instagram',
        link: 'https://www.instagram.com/smartclub_women/'
    },
    {
        img: tiktok,
        title: 'tiktok',
        link: 'https://www.tiktok.com/@smartclub_women'
    },
    {
        img: facebook,
        title: 'facebook',
        link: 'https://www.facebook.com/profile.php?id=100079080106361'
    }
]